<template>
  <div :class="['step-block', { 'step-block-open': !folded }]">
    <div v-if="!folded" class="green-line"></div>
    <div
      class="header"
      :class="{ 'open-header': !folded }"
      @click="toggleFold"
      @keydown.enter="toggleFold"
      @keydown.space.prevent="toggleFold"
      role="button"
      tabindex="0"
      :aria-expanded="(!folded).toString()"
      :aria-controls="contentId"
    >
      <div class="icon-container">
        <svg
          class="icon"
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.52832" width="26" height="26" rx="13" fill="#4DC1BE" />
          <g clip-path="url(#clip0_5970_6567)">
            <path
              d="M18.2908 9.98756C18.5697 10.2665 18.5697 10.7196 18.2908 10.9986L12.5771 16.7123C12.2981 16.9912 11.8451 16.9912 11.5661 16.7123L8.70924 13.8554C8.43025 13.5764 8.43025 13.1234 8.70924 12.8444C8.98823 12.5654 9.4413 12.5654 9.72029 12.8444L12.0727 15.1946L17.2819 9.98756C17.5609 9.70857 18.014 9.70857 18.293 9.98756H18.2908Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5970_6567">
              <rect width="10" height="10" fill="white" transform="translate(8.5 8.52832)" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div
        class="col-xs-2 col-sm-2 col-md-2 col-lg-1 f-right fold-button"
        :class="{ reversed: folded }"
      >
        <span
          v-if="folded"
          class="icon-more"
          role="img"
          :aria-label="$t('tracking.alt.plus_picto')"
        ></span>
        <span
          v-if="!folded"
          class="icon-minus"
          role="img"
          :aria-label="$t('tracking.alt.minus_picto')"
        ></span>
      </div>
      <div class="hidden-xs col-sm-1 -md-1 col-lg-1 f-left">
        <svg
          class="icon-open"
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          :aria-label="$t('tracking.alt.valid_picto')"
        >
          <rect x="0.5" y="0.52832" width="26" height="26" rx="13" fill="#4DC1BE" />
          <g clip-path="url(#clip0_5970_6567)">
            <path
              d="M18.2908 9.98756C18.5697 10.2665 18.5697 10.7196 18.2908 10.9986L12.5771 16.7123C12.2981 16.9912 11.8451 16.9912 11.5661 16.7123L8.70924 13.8554C8.43025 13.5764 8.43025 13.1234 8.70924 12.8444C8.98823 12.5654 9.4413 12.5654 9.72029 12.8444L12.0727 15.1946L17.2819 9.98756C17.5609 9.70857 18.014 9.70857 18.293 9.98756H18.2908Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5970_6567">
              <rect width="10" height="10" fill="white" transform="translate(8.5 8.52832)" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="summary-container">
        <div class="summary-date">{{ firstDateOfDay }}</div>
        <div class="summary-text">{{ summaryText }}</div>
      </div>
    </div>
    <transition name="stepcard">
      <div :id="contentId" :class="{ folded: folded }" v-if="!folded">
        <PartnerLine v-if="showPartnerLine" :partnerInfos="partnerInfos" />
        <div v-for="(step, index) in stepsReversed" :key="stepKey(step, index)">
          <StepLine
            :step="step"
            :index="index"
            :stepCount="stepCount"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PartnerLine from '../PartnerLine/PartnerLine';
import StepLine from '../StepLine/StepLine';
import { isoToLocaleDate, toDateKey } from '@/utils';

export default {
  components: {
    StepLine,
    PartnerLine,
  },
  props: {
    stepDay: { type: Array, required: true },
    isFirstCard: { type: Boolean, default: false },
    partnerInfos: { type: Object, default: null },
  },
  data() {
    return {
      folded: true,
      uid: Math.random().toString(36).slice(2),
    };
  },
  computed: {
    contentId() {
      return `stepcard-content-${this.uid}`;
    },
    firstDateOfDay() {
      const first = this.stepDay && this.stepDay[0];
      if (!first) return '';
      const iso = toDateKey(first.Date);
      return isoToLocaleDate(iso, 'fr-FR');
    },
    summaryText() {
      const arr = this.stepDay || [];
      const last = arr.length ? arr[arr.length - 1] : null;
      return last ? last.Libelle : '';
    },
    stepsReversed() {
      return [...(this.stepDay || [])].reverse();
    },
    stepCount() {
      return (this.stepDay || []).length;
    },
    showPartnerLine() {
      const url = this.partnerInfos?.UrlSuiviColisPartenaire;
      return this.isFirstCard && typeof url === 'string' && url.trim().length > 0;
    },
  },
  methods: {
    toggleFold() {
      this.folded = !this.folded;
    },
    stepKey(step, index) {
      const date = step?.Date || '';
      const lib = step?.Libelle || '';
      return `stp-${date}-${lib}-${index}`;
    },
  },
  created() {
    if (this.isFirstCard) this.folded = false;
  },
};
</script>

<style scoped lang="scss">
@import './StepCard.scss';
</style>
